import actions from '@/core/store/item-ata/aditamento/aditar/actions'
import state from '@/core/store/item-ata/aditamento/aditar/state'
import mutations from '@/core/store/item-ata/aditamento/aditar/mutations'

export default { actions, state, mutations }
